import { render, staticRenderFns } from "./translation-content.vue?vue&type=template&id=9794df72&scoped=true"
import script from "./translation-content.vue?vue&type=script&lang=ts"
export * from "./translation-content.vue?vue&type=script&lang=ts"
import style0 from "./translation-content.vue?vue&type=style&index=0&id=9794df72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794df72",
  null
  
)

export default component.exports